import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=22df7ddb&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"
import style0 from "./Clients.vue?vue&type=style&index=0&id=22df7ddb&prod&lang=scss&scoped=true"
import style1 from "./Clients.vue?vue&type=style&index=1&id=22df7ddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df7ddb",
  null
  
)

export default component.exports